import { PageTypeSuffix } from '@/constants'
import { type Category } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import 'react-loading-skeleton/dist/skeleton.css'
import type { Settings } from 'react-slick'
import ImageOptimize from '../../ImageOptimize'
import Slider from '../../Slider/Slider'

interface ChildrenCategoryListProps {
  data: Category[]
}

const ChildrenCategoryList = ({ data }: ChildrenCategoryListProps) => {
  const isOneRow = (data || []).length <= 5

  const settingsOneRow: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesPerRow: 5,
    slidesToScroll: 1,
    centerPadding: '10px',
    rows: isOneRow ? 1 : 2,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  }

  return data?.length ? (
    <Slider {...settingsOneRow} className='-my-2'>
      {data.map(item => (
        <div key={item._id}>
          <Link
            href={`/${
              getTranslate(item.slugs.value) + PageTypeSuffix.CATEGORY
            }`}
            className='m-2 flex h-[120px] grow gap-3 rounded-sm bg-white p-3'
          >
            <span className='block w-1/2 grow text-lg font-semibold text-main'>
              {getTranslate(item.name)}
            </span>
            <ImageOptimize
              src={item.image}
              alt={getTranslate(item.name)}
              width={88}
              height={88}
              className='aspect-square h-[88px] object-contain'
            />
          </Link>
        </div>
      ))}
    </Slider>
  ) : null
}
export default ChildrenCategoryList
